import MainLogo from '../../assets/images/Logo_launch_capital.svg'; 
import Poweredby from "../../assets/images/company-logo.png"

const Logos = {
  MainLogo,
  Poweredby,
};

export default Logos;
